// store/authStore.js
import { create } from "zustand";
import { getBannerData, getCapabilityData, getHomeData } from "../api/home";

export const useHomeStore = create((set, get) => ({
    loading: true,
    about: null,
    banner: null,
    capability: null,
    serviceArea: null,
    project: null,
    marketArea: null,
    analytics: null,
    getHome: async () => {
        try {
            set({ loading: true })
            const res = await getHomeData()
            set({
                loading: false,
                about: res?.about,
                marketArea: res?.marketArea,
                serviceArea: res?.serviceArea,
                analytics: res?.analytics,
            })
            return res
        } catch (error) {
            console.log("Error in checkAuth:", error);
            set({ authUser: null, hasTriedAuth: true, loading: false });
            return false;
        } finally {
            set({ isCheckingAuth: false, hasTriedAuth: true, loading: false });
        }
    },
    getBanner: async () => {
        try {
            set({ loading: true })
            const res = await getBannerData('home')
            set({ loading: false, banner: res })
            return res
        } catch (error) {
            console.log("Error in checkAuth:", error);
            set({ authUser: null, hasTriedAuth: true });
            return false;
        } finally {
            set({ isCheckingAuth: false, hasTriedAuth: true });
        }
    },
    getCapability: async () => {
        try {
            set({ loading: true })
            const res = await getCapabilityData()
            console.log("capability", res);
            set({ loading: false, capability: res })
            return res
        } catch (error) {
            console.log("Error in checkAuth:", error);
            set({ authUser: null, hasTriedAuth: true });
            return false;
        } finally {
            set({ isCheckingAuth: false, hasTriedAuth: true });
        }
    }

}));
